import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, Subscription } from 'rxjs';

import { COMMON_BOOKING_TRAVEL_CLASSES, GlobalBookingTravelClass } from '@fcom/core';
import { unsubscribe } from '@fcom/core/utils';

@Component({
  selector: 'fin-destination-search-travel-class-selection',
  templateUrl: 'destination-search-travel-class-selection.component.html',
  styleUrls: ['destination-search-travel-class-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DestinationSearchTravelClassSelectionComponent implements OnInit, OnDestroy {
  readonly COMMON_BOOKING_TRAVEL_CLASSES = COMMON_BOOKING_TRAVEL_CLASSES;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  modalOpen = false;

  @Input()
  travelClasses: GlobalBookingTravelClass[] = [
    GlobalBookingTravelClass.MIXED,
    GlobalBookingTravelClass.ECONOMY,
    GlobalBookingTravelClass.BUSINESS,
  ];

  @Input()
  initialTravelClass$: Observable<GlobalBookingTravelClass>;

  @Output()
  selectedTravelClassChange = new EventEmitter<GlobalBookingTravelClass>();

  selectedTravelClass: GlobalBookingTravelClass = GlobalBookingTravelClass.MIXED;

  private subscriptions = new Subscription();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.travelClasses.splice(2, 0, GlobalBookingTravelClass.ECOPREMIUM);

    this.subscriptions.add(
      this.initialTravelClass$.subscribe((travelClass) => {
        this.selectedTravelClass = travelClass;
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscriptions);
  }

  closeModal(): void {
    this.modalOpen = false;
  }

  openModal(): void {
    this.modalOpen = true;
  }

  selectTravelClass(travelClass: GlobalBookingTravelClass): void {
    this.selectedTravelClass = travelClass;
    this.selectedTravelClassChange.emit(this.selectedTravelClass);
    this.closeModal();
  }
}
